import {
    S3,
    GetObjectCommand,
    PutObjectCommand,
    DeleteObjectCommand,
} from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

const REGION = process.env.AWS_REGION || 'sa-east-1';
const BUCKET = process.env.S3_BUCKET || 'qrmania';
const ACCESS_KEY = process.env.ACCESS_KEY || 'AKIA47CRZHWL5TDOGNEE';
const SECRET_KEY = process.env.SECRET_KEY || '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';

if (!REGION || !BUCKET || !ACCESS_KEY || !SECRET_KEY) {
    throw new Error('Faltam variáveis de ambiente obrigatórias para o S3');
}

const getS3Instance = () =>
    new S3({
        region: REGION,
        credentials: {
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
        },
    });

export interface FileData {
    name: string;
    data: Buffer;
    mimetype: string;
}

export const sendImagemToS3 = async (file: File, establishmentName: string): Promise<string | void> => {
    const s3 = await getS3Instance()
    const key = `${establishmentName}/capa/${file.name}`;
    const command = new PutObjectCommand({
        Bucket: process.env.S3_BUCKET || 'qrmania',
        Key: key,
        Body: file,
        ContentType: file.type
    })
    await s3.send(command);
    return key
}

export const authenticateS3Link = async (fileKey: string): Promise<string> => {
    const s3 = getS3Instance();

    const command = new GetObjectCommand({ Bucket: BUCKET, Key: fileKey });
    return getSignedUrl(s3, command, { expiresIn: 15 * 60 }); // 15 minutos
};

export const removeObjectToBucket = async (nomeObjeto: string): Promise<void> => {
    const s3 = getS3Instance();

    const command = new DeleteObjectCommand({
        Bucket: BUCKET,
        Key: nomeObjeto,
    });

    try {
        await s3.send(command);
    } catch (error) {
        console.error('Erro ao remover objeto do S3:', error);
        throw new Error('Erro ao remover objeto do S3');
    }
};